// src/hooks/useBlobManifest.ts
import { useEffect } from 'react';

/**
 * Trasforma un manifest remoto (S3, backend 8000) in un
 * blob-URL same-origin, requisito per l’installabilità in dev.
 * @param manifestUrl URL assoluto/relativo del manifest
 */
export function useBlobManifest(manifestUrl?: string): void {
  useEffect(() => {
    if (!manifestUrl) return;

    // crea (o riusa) <link rel="manifest" id="dynamic-manifest">
    let link = document.querySelector<HTMLLinkElement>('#dynamic-manifest');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'manifest';
      link.id = 'dynamic-manifest';
      document.head.appendChild(link);
    }

    // scarica il JSON, patcha start_url / scope se mancano, genera blob url
    fetch(manifestUrl)
      .then((r) => r.json())
      .then((json: Record<string, unknown>) => {
        const origin = window.location.origin;
        json.start_url = `${origin}/`; // URL assoluto = same-origin della pagina
        json.scope = `${origin}/`;

        const blob = new Blob([JSON.stringify(json)], {
          type: 'application/manifest+json',
        });
        link!.href = URL.createObjectURL(blob);
      })
      .catch(console.error);

    return () => {
      if (link && link.href.startsWith('blob:')) {
        URL.revokeObjectURL(link.href);
      }
      link?.remove();
    };
  }, [manifestUrl]);
}
